
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.25 13.5A5.249 5.249 0 0 0 18 8.25h-3a5.25 5.25 0 0 0 0 10.5h.75l4.5 4.5v-5.024a5.237 5.237 0 0 0 3-4.726Zm-16.5-.75-3 3v-5.024A5.239 5.239 0 0 1 6 .75h3a5.252 5.252 0 0 1 5.033 3.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    